import React from "react";

const Select = ({ id, label, name, className, options, value, onChange }) => {
  return (
    <div className={`select-box ${className || ""}`}>
      <label htmlFor={id}>{label}</label>
      <select id={id} name={name} value={value ?? ""} onChange={onChange}>
        <option value="" disabled>
          Select an option
        </option>
        {options?.map(item => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
